
@if (harvest != null) {
  <div class="pc-hd">

    <!-- ── Header ──────────────────────────────────────────────────────── -->
    <header class="pc-hd-header">
      <button class="pc-hd-back" (click)="backToHarvestList()" title="Back to Harvests">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="pc-hd-title">
        <div class="pc-hd-name-row" [class.pc-editable]="canEditHarvest" (click)="editHarvest()">
          <span class="pc-hd-dot" [style.background]="color ? color : '#0066FF'"></span>
          <h2 class="pc-hd-name">{{ harvest.name }}</h2>
          @if (canEditHarvest) {
            <mat-icon class="pc-hd-edit-hint">edit</mat-icon>
          }
        </div>
        <div class="pc-hd-meta">
          <a class="pc-hd-meta-item pc-hd-link" (click)="navigateToTemplateDetails()" title="Open template">
            <mat-icon>description</mat-icon>
            <span>{{ templateUsedForHarvest?.name }}</span>
          </a>
          @if (pageLoaded) {
            <span class="pc-hd-meta-item" title="Clone date">
              <mat-icon>schedule</mat-icon>
              <span>Cloned {{ startDate?.seconds * 1000 | date:'MM/dd/yyyy' }}</span>
            </span>
            <span class="pc-hd-meta-item" title="End date">
              <mat-icon>flag</mat-icon>
              <span>Ends {{ endDate?.seconds * 1000 | date:'MM/dd/yyyy' }}</span>
            </span>
          }
          @if (harvest.leaflogixName != null) {
            <span class="pc-hd-meta-item pc-hd-dutchie" title="Linked Dutchie batch">
              <mat-icon>link</mat-icon>
              <span>{{ harvest.leaflogixName }}</span>
              @if (dutchieAdmin) {
                <button class="pc-hd-unlink" [disabled]="unlinking" (click)="unlinkClick()" title="Unlink Dutchie batch">
                  @if (unlinking) {
                    <mat-spinner diameter="14" strokeWidth="3"></mat-spinner>
                  } @else {
                    <mat-icon>close</mat-icon>
                  }
                </button>
              }
            </span>
          }
          @if (dutchieAdmin && harvest.leaflogixName == null) {
            <a class="pc-hd-meta-item pc-hd-link" (click)="linkToDutchieBatch()">
              @if (!linking) {
                <mat-icon>add_link</mat-icon>
                <span>Link to Dutchie Batch</span>
              } @else {
                <mat-spinner diameter="14" strokeWidth="3"></mat-spinner>
              }
            </a>
          }
        </div>
      </div>

      <div class="pc-hd-actions">
        @if ((canEditHarvest || canCompleteEvent) && saveBtnEnabled) {
          <button mat-button class="pc-hd-discard" (click)="undoClick()">Discard</button>
          <button mat-raised-button color="primary" (click)="saveClick()">
            <mat-icon>save</mat-icon> Save
          </button>
        }
        @if (eventListComponent != null && canAddEvent) {
          <button mat-raised-button color="primary" class="pc-hd-add" [matMenuTriggerFor]="addeventmenu"
            [disabled]="eventListComponent?.hasPendingChanges" title="Add Event">
            <mat-icon>add</mat-icon> Add Event
          </button>
        }
        <button mat-raised-button class="gridbtn pc-hd-kebab" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          @if (canEditHarvest) {
            <app-harvest-shift-btn [disabled]="saveBtnEnabled" [dropDownMenu]=true [harvest]="harvest"></app-harvest-shift-btn>
          }
          @if (canEditHarvest) {
            <button mat-menu-item [disabled]="saveBtnEnabled" (click)="backfillTemplate()" title="Backfill Template">
              <mat-icon aria-hidden="false" aria-label="Backfill Template">bookmark_add</mat-icon>
              <span>Backfill Template</span>
            </button>
          }
          @if (canEditHarvest) {
            <app-harvest-delete-btn [harvest]="harvest" (doneDeleting)="backToHarvestList()"></app-harvest-delete-btn>
          }
          <button mat-menu-item (click)="harvestDocuments()" title="Harvest Documents">
            <mat-icon aria-hidden="false" aria-label="Harvest Documents">folder_open</mat-icon>
            <span>Harvest Documents</span>
          </button>
          @if (canEditHarvest) {
            <mat-divider></mat-divider>
          }
          <app-apply-workflow-btn [showApplyToGroupButton]="false" [harvestId]="harvest.uid"></app-apply-workflow-btn>
        </mat-menu>
        <mat-menu #addeventmenu="matMenu">
          <button mat-menu-item (click)="addEvent(null)">
            <mat-icon>add</mat-icon>
            <span>Event</span>
          </button>
          <button mat-menu-item (click)="addEventFromLibrary()">
            <mat-icon>add_task</mat-icon>
            <span>Add From Library</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <!-- ── KPI strip (3–5 tiles, only what's populated) ───────────────── -->
    @if (pageLoaded) {
      <section class="pc-hd-kpis">

        <div class="pc-kpi" [class.pc-kpi-complete]="cycleState === 'complete'">
          <div class="pc-kpi-label">Cycle</div>
          @if (cycleState === 'active') {
            <div class="pc-kpi-value">Day {{ cycleDayNumber }} <span class="pc-kpi-of">of {{ cycleTotalDays }}</span></div>
            <div class="pc-kpi-sub">
              @if (currentPhaseName) {
                <span class="pc-kpi-phase">{{ currentPhaseName }}</span>
              } @else {
                In progress
              }
            </div>
          } @else if (cycleState === 'upcoming') {
            <div class="pc-kpi-value">Starts in {{ cloneDaysDif }}<span class="pc-kpi-of"> days</span></div>
            <div class="pc-kpi-sub">{{ cycleTotalDays }}-day plan</div>
          } @else {
            <div class="pc-kpi-value">Complete</div>
            <div class="pc-kpi-sub">{{ cycleTotalDays }}-day cycle</div>
          }
        </div>

        <div class="pc-kpi">
          <div class="pc-kpi-label">Tasks</div>
          <div class="pc-kpi-value">
            {{ numberOfCompletedEvents }} <span class="pc-kpi-of">/ {{ numberOfEvents }}</span>
          </div>
          <div class="pc-kpi-progress">
            <div class="pc-kpi-progress-fill" [style.width]="percentOfEventsCompletedString"></div>
          </div>
          <div class="pc-kpi-sub">
            @if (overdueCount > 0) {
              <span class="pc-kpi-overdue">
                <mat-icon>error_outline</mat-icon> {{ overdueCount }} overdue
              </span>
            } @else {
              On track
            }
          </div>
        </div>

        <div class="pc-kpi" [class.pc-kpi-warn]="harvestDaysDif != null && harvestDaysDif >= 0 && harvestDaysDif <= 7">
          <div class="pc-kpi-label">Harvest</div>
          @if (harvestDaysDif > 0) {
            <div class="pc-kpi-value">In {{ harvestDaysDif }} <span class="pc-kpi-of">{{ harvestDaysDif === 1 ? 'day' : 'days' }}</span></div>
          } @else if (harvestDaysDif === 0) {
            <div class="pc-kpi-value">Today</div>
          } @else {
            <div class="pc-kpi-value">{{ harvestDate?.seconds * 1000 | date:'MMM d' }}</div>
          }
          <div class="pc-kpi-sub">
            @if (harvestDaysDif < 0) {
              Harvested {{ harvestDaysDifAbs }} days ago
            } @else {
              {{ harvestDate?.seconds * 1000 | date:'MM/dd/yyyy' }}
            }
          </div>
        </div>

        @if (showLaborTile) {
          <div class="pc-kpi">
            <div class="pc-kpi-label">Labor</div>
            <div class="pc-kpi-value">
              {{ formatMinutes(laborSpentMinutes) }}
              @if (laborEstMinutes > 0) {
                <span class="pc-kpi-of">of {{ formatMinutes(laborEstMinutes) }} est.</span>
              }
            </div>
            <div class="pc-kpi-sub">across {{ laborEventCount }} {{ laborEventCount === 1 ? 'task' : 'tasks' }}</div>
          </div>
        }

        @if (showStrainZoneTile) {
          <div class="pc-kpi">
            <div class="pc-kpi-label">Growing</div>
            <div class="pc-kpi-value">
              {{ strainCount }} <span class="pc-kpi-of">{{ strainCount === 1 ? 'strain' : 'strains' }}</span>
            </div>
            <div class="pc-kpi-sub">
              @if (zoneCount > 0) {
                {{ zoneCount }} {{ zoneCount === 1 ? 'zone' : 'zones' }} assigned
              } @else {
                No zones assigned
              }
            </div>
          </div>
        }
      </section>
    }

    <!-- ── Phase timeline ─────────────────────────────────────────────── -->
    <mat-accordion class="pc-hd-timeline">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>Timeline</mat-panel-title>
        </mat-expansion-panel-header>
        <app-timeline [dataList]="timelineData"></app-timeline>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- ── Tabs ───────────────────────────────────────────────────────── -->
    <mat-tab-group class="pc-hd-tabs" mat-align-tabs="start">
      <mat-tab label="Events">
        <app-event-list [collectionType]="collectionType" [collectionId]="harvestId" [collectionName]="harvest?.name" [company]="company" (eventListChange)="eventListChange($event)"></app-event-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Detail</span>
        </ng-template>
        <div class="pc-hd-detail" [hidden]="!canEditHarvest">
          <div class="pc-hd-strains" [hidden]="allStrains.length == 0 || harvest.phases == null || harvest.phases.length == 0">
            <h3 class="pc-hd-section-title">Strains</h3>
            <app-strain-select-multiple-for-harvest
              [(allStrains)]="allStrains"
              [(strainIds)]="harvest.strainIds"
              [(harvestPhases)]="harvest.phases">
            </app-strain-select-multiple-for-harvest>
          </div>
        </div>
        <app-phase-accordion [(harvest)]="harvest" [allStrains]="allStrains" [canEditHarvest]="canEditHarvest"></app-phase-accordion>
      </mat-tab>
    </mat-tab-group>
  </div>
}
